enum ANCHOR {
	HOME = '/',
	BLOG = '/blog',
	CASE_STUDIES = '/case-studies',
	NEWSLETTER = '#newsletter'
}

export default ANCHOR;
